import { useRoiConfig } from '@/dashboards/SpendSummary/hooks/useRoiConfig';
import { Tooltip } from '@analytical-alley/ui';
import { IconExclamationCircle } from '@tabler/icons-react';

/** Explains what the project's ROI flavour means. Used by the KPI card and the table header. */
export const RoiInfoTooltip = () => {
    const { description } = useRoiConfig();

    return (
        <Tooltip>
            <Tooltip.Trigger>
                <span className="cursor-pointer">
                    <IconExclamationCircle className="w-5" />
                </span>
            </Tooltip.Trigger>
            <Tooltip.Content className="tooltip-content">
                {description}
            </Tooltip.Content>
        </Tooltip>
    );
};
